import React from 'react';

const EnvBadge = () => {
  const raw = import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'development';
  const env = String(raw).toLowerCase();
  const isProd = env === 'production' || env === 'prod' || env.startsWith('prod');
  if (isProd) return null;

  let label = '';
  if (env === 'development' || env === 'dev') label = 'DEV';
  else if (env === 'test' || env === 'testing') label = 'TEST';
  else label = String(raw).toUpperCase();

  const styles = {
    position: 'fixed',
    top: '10px',
    right: '10px',
    zIndex: 5000,
    padding: '6px 10px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 700,
    color: '#fff',
    background: label === 'TEST' ? '#6f42c1' : '#ff9800',
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    letterSpacing: '0.5px',
    userSelect: 'none'
  };

  return (
    <div style={styles} title={`Environment: ${label}`}>
      {label}
    </div>
  );
};

export default EnvBadge;
